<label for="txt-address1" 
       [class.visible-label]="isMobileView">
       {{'HOMEOWNERS.ADDRESS1_PLACEHOLDER' | translate }}
</label>
<div class="input-group mb-4">
       <input 
              type="text" 
              class="form-control"
              id="txt-address1"
              name="street"
              [(ngModel)]="autocompleteInput"
              placeholder="{{'HOMEOWNERS.ADDRESS1_PLACEHOLDER' | ceaPlaceholder: !isMobileView | translate }}"
              #addresstext
              (keyup)="getAddressFromInput($event)"
              attr.aria-label="{{'HOMEOWNERS.ADDRESS1_PLACEHOLDER' | translate}}"
              ebbGoogleAutocomplete
              (whenSelected)="openDropdown($event)"
              (focus)="onFocus($event)" />
       <div
              *ngIf="listResults.length"
              id="resultDropDown"
              class="pac-container pac-logo"
              #resultDropDown>
              <div
                     [class.pac-item-selected]="result.selected"
                     class="pac-item"
                     *ngFor="let result of listResults"
                     (click)="getPlaceDetails(result)">
                     <span class="pac-icon pac-icon-marker"></span>
                     <span class="pac-item-query">
                            {{result.text}}
                     </span>
              </div>
       </div>
       <span class="input-group-text input-group-text-required">*</span>    
</div>
